import React, { useEffect, useState } from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
  ListItemButton,
  Collapse,
  Theme,
  SxProps,
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  // Category as CategoryIcon,
  // Restaurant as RestaurantIcon,
  ListAlt as ListAltIcon,
  LocalShipping as DeliveryIcon,
  Person as CustomerIcon,
  Inventory as ItemIcon,
  ExpandLess,
  ExpandMore,
  //Quiz
} from '@mui/icons-material';
import SettingsIcon from '@mui/icons-material/Settings';
import { useNavigate, useLocation } from 'react-router-dom';
import { COLORS } from '../../theme/themeConstants';
import { usePermissions } from '../../context/PermissionContext';

const drawerWidth = 300;

interface SidebarProps {
  open: boolean;
  onClose: () => void;
}

interface MenuItem {
  text: string;
  // icon: React.ReactElement;
  path: string;
  submenu?: boolean; // Optional flag to determine if it has a submenu
  reviewType?: 'Item' | 'Store' | 'DeliveryPerson';
}

interface MainMenuItem {
  text: string;
  icon: React.ReactElement;
  path: string;
  submenu?: boolean; // Optional flag to determine if it has a submenu
}

// Extracted styles
const drawerStyles = (open: boolean): SxProps<Theme> => ({
  width: open ? drawerWidth : 0,
  flexShrink: 0,
  position: 'fixed',
  height: '100%',
  '& .MuiDrawer-paper': {
    width: drawerWidth,
    boxSizing: 'border-box',
    backgroundColor: COLORS.sidebar?.main || COLORS.background.main,
    color: '#A5A9C2',
    borderRight: 'none',
    height: '100%',
    transform: open ? 'none' : `translateX(-${drawerWidth}px)`,
    transition: 'transform 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
    visibility: 'visible !important',
    overflowX: 'hidden',
    marginTop: '64px',
    paddingBottom: '64px',
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
      borderRadius: '3px',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent',
    },
  },
});

const listItemStyles = (isSelected: boolean): SxProps<Theme> => ({
  minHeight: 48,
  px: 2.5,
  backgroundColor: isSelected ? COLORS.primary.main : 'transparent',
  color: isSelected ? COLORS.secondary.main : '#A5A9C2',
  '&.Mui-selected': {
    backgroundColor: COLORS.primary.main,
    color: COLORS.secondary.main,
    '&:hover': {
      backgroundColor: COLORS.primary.main,
    },
    '& .MuiListItemIcon-root': {
      color: COLORS.secondary.main,
    },
  },
  '&:hover': {
    backgroundColor: isSelected ? COLORS.primary.main : 'rgba(255, 87, 34, 0.08)',
  },
});

const listItemStyless = (isSelected: boolean): SxProps<Theme> => ({
  minHeight: 48,
  padding: "8px 20px 8px 56px",
  backgroundColor: isSelected ? COLORS.primary.main : 'transparent',
  color: isSelected ? COLORS.secondary.main : '#A5A9C2',
  '&.Mui-selected': {
    backgroundColor: COLORS.primary.main,
    color: COLORS.secondary.main,
    '&:hover': {
      backgroundColor: COLORS.primary.main,
    },
    '& .MuiListItemIcon-root': {
      color: COLORS.secondary.main,
    },
  },
  '&:hover': {
    backgroundColor: isSelected ? COLORS.primary.main : 'rgba(255, 87, 34, 0.08)',
  },
});


const listItemIconStyles = (isSelected: boolean): SxProps<Theme> => ({
  minWidth: 40,
  color: isSelected ? COLORS.secondary.main : '#A5A9C2',
});

const listItemTextStyles = {
  '& .MuiTypography-root': {
    fontSize: '0.9rem',
  },
};

// Memoized menu items
const settingsMenuItems: MenuItem[] = [
  // { text: 'General Settings', path: '/settings/general' },
  // { text: 'Onboarding Settings', path: '/onBoardingSettings' },
  // { text: 'Social Media Settings', path: '/socialMediaSettings' },
  // { text: 'Map Settings', path: '/mapSettings' },
  // { text: 'Design Settings', path: '/designSettings' },
   { text: 'General Settings', path: '/settings/general' },
  // { text: 'Banner Settings', path: '/bannerSettings' },
  // { text: 'SMTP Settings', path: '/settings/smtp' },
  // { text: 'SMS & Notification Settings', path: '/settings/notifications' },
  // { text: 'Image Settings', path: '/settings/image' },
  // { text: 'No Image Settings', path: '/settings/no-image' },
  { text: 'Payment Settings', path: '/settings/payment' },
  // { text: 'Manage Banner', path: '/settings/banner' },
  // { text: 'Manage Advertisement', path: '/settings/advertisement' },
  // { text: 'App Version Settings', path: '/settings/app-version' },
  // { text: 'App Image Settings', path: '/settings/app-image' },
  // { text: 'Manage Email Templates', path: '/settings/email-templates' },
  // { text: 'Manage SMS Templates', path: '/settings/SMS-templates' },
];

const subAdminMenuItems: MenuItem[] = [
  { text: 'Manage Sub Admin List', path: '/sub-admin/list' },
];

const categoriesMenuItems: MenuItem[] = [
  { text: 'Manage Store Category', path: '/managecuisine' },
  { text: 'Manage Item Category', path: '/manageItemCategory' },
];

const restaurantOwnerManagementMenuItems: MenuItem[] = [
  { text: 'Add Store Owner', path: '/store-owner/add' },
  { text: 'Manage Store Owner ', path: '/store-owner' },
];

const manageChoiceMenuItems: MenuItem[] = [
  { text: 'Add Choice group', path: '/add-choice-group' },
  { text: 'Manage Choice Group', path: '/manage-choice-group' },
];

const restaurantManagementMenuItems: MenuItem[] = [
  // { text: 'Add Restaurant', path: '/addRestaurant' },
  { text: 'Store Management', path: '/manage-store' },
];

const customerManagementMenuItems: MenuItem[] = [
  // { text: 'Add Customer', path: '/add-customer' },
  { text: 'Manage Customer', path: '/manageCustomer' },
];

const itemManagementMenuItems: MenuItem[] = [
  // { text: 'Add Item', path: '/addStoreItem' },
  { text: 'Manage Item', path: '/manageStoreItem' },
  // { text: 'Item Bulk Upload', path: '/item-upload' },
];
const adminDeliveryManagerMenuItems: MenuItem[] = [
  { text: 'Add Admin Delivery Manager', path: '/add' },
  { text: 'Manage Delivery Manager', path: '/manage' },
];
const deliveryboyMenuItems: MenuItem[] = [
  { text: 'Add Delivery boy', path: '/add' },
  { text: 'Manage Delivery boy', path: '/manage' },
];

const manageCouponMenuItems: MenuItem[] = [
  // { text: 'Add Coupon', path: '/add' },
  { text: 'Manage Coupon', path: '/manageCoupon' },
];

const manageCMS: MenuItem[] = [
  // { text: 'Add CMS', path: '/add' },
  { text: 'Manage CMS', path: '/manage' },
];

const manageFAQ: MenuItem[] = [
  // { text: 'Add FAQ', path: '/add' },
  { text: 'Manage FAQ', path: '/manage-FAQ' },
];

const reviewManagement: MenuItem[] = [
  { text: 'Manage Restaurant Review', path: '/manage-restaurant-review', reviewType: 'Store' },
  { text: 'Manage Delivery Review', path: '/manage-order-review', reviewType: 'DeliveryPerson' },
];


const newsletterManagement: MenuItem[] = [
  // { text: 'Manage Subscriber', path: '/add' },
  { text: 'Newsletter Management', path: '/manage' },
];

const promotionalOffers: MenuItem[] = [
  { text: 'Manage Offers', path: '/Manage-Offers' },
  { text: 'Assign Offers and Loyalty Rewards', path: '/assign-offers' },
];

const reports: MenuItem[] = [
  { text: 'Sales Reports', path: '/reports/store-earning-reports' },
  { text: 'Cancelled Orders Report', path: '/reports/cancelled-orders' },
  // { text: 'Order Summary Report', path: '/reports/order-summary' },
  { text: 'Rejected Orders Report', path: '/reports/rejected-orders' },
  { text: 'Pending Orders Report', path: '/reports/pending-orders' },
  { text: 'Delivery Performance Report', path: '/reports/delivery-performance' },
  { text: 'Admin Commission Report', path: '/reports/admin-commission' },
  { text: 'Merchant Payout Report', path: '/reports/merchant-payout' },
  { text: 'Driver Payout Report', path: '/reports/driver-payout' },
  { text: 'Refund Report', path: '/reports/refund' },
];

// Updated mainMenuItems with submenu flag
const mainMenuItems: MainMenuItem[] = [
  {
    text: 'Dashboard',
    icon: <DashboardIcon />,
    path: '/dashboard',
    submenu: false,
  },

  {
    text: 'Sub Admin',
    icon: <ListAltIcon />,
    path: '/sub-admin/list',
    submenu: false,
  },
  // {Manage Store Sub Category
  //   text: 'Category Management',
  //   icon: <ListAltIcon />,
  //   path: '/categories',
  //   submenu: true,
  // },
  {
    text: 'Manage Store Category',
    icon: <ListAltIcon />,
    path: '/managecuisine',
    submenu: false,
  },
  {
    text: 'Manage Item Category',
    icon: <ListAltIcon />,
    path: '/manageItemCategory',
    submenu: false,
  },

  {
    text: 'Manage Choice Group',
    icon: <ListAltIcon />,
    path: '/manage-choice-group',
    submenu: false,
  },
  {
    text: 'Manage Choices',
    icon: <ListAltIcon />,
    path: '/manage-choice',
    submenu: false,
  },
  {
    text: 'Store Owner Management',
    icon: <CustomerIcon />,
    path: '/store-owner',
    submenu: false,
  },
  {
    text: 'Store Management',
    icon: <ItemIcon />,
    path: '/manage-store',
    submenu: false,
  },
  {
    text: 'Customer Management',
    icon: <CustomerIcon />,
    path: '/manageCustomer',
    submenu: false,
  },
  {
    text: 'Join Us Requests',
    icon: <CustomerIcon />,
    path: '/join-us',
    submenu: false,
  },
  // {
  //   text: 'Manage Item',
  //   icon: <CustomerIcon />,
  //   path: '/manageStoreItem',
  //   submenu: false,
  // },
  // {
  //   text: 'Item Management',
  //   icon: <DeliveryIcon />,
  //   path: '/item-management',
  //   submenu: true,
  // },
  // {
  //   text: 'Admin Delivery Manager',
  //   icon: <DeliveryIcon />,
  //   path: '/admin-delivery',
  //   submenu: true,
  // },
  {
    text: 'Delivery boy / Driver Management',
    icon: <CustomerIcon />,
    path: '/delivery-boy',
    submenu: false,
  },
  {
    text: 'Item Management',
    icon: <ItemIcon />,
    path: '/manageStoreItem',
    submenu: false,
  },
  // {
  //   text: 'Admin Delivery Manager',
  //   icon: <DeliveryIcon />,
  //   path: '/admin-delivery',
  //   submenu: false,
  // },
  // {
  //   text: 'Delivery boy / Driver Management',
  //   icon: <DeliveryIcon />,
  //   path: '/delivery-boys',
  //   submenu: true,
  // },
  {
    text: 'Manage Coupon',
    icon: <DeliveryIcon />,
    path: '/manageCoupon',
    submenu: false,
  },
  {
    text: 'Manage CMS',
    icon: <DeliveryIcon />,
    path: '/manage-CMS',
    submenu: false,
  },
  {
    text: 'Manage FAQ',
    icon: <DeliveryIcon />,
    path: '/manage-FAQ',
    submenu: false,
  },
  {
    text: 'Review Management',
    icon: <DeliveryIcon />,
    path: '/review-management',
    submenu: true,
  },
  {
    text: 'Newsletter Management',
    icon: <DeliveryIcon />,
    path: '/newsletter-management',
    submenu: false,
  },
  {
    text: 'Customer Order Management',
    icon: <DeliveryIcon />,
    path: '/manageOrder',
    submenu: false,
  },
  {
    text: 'Manage Customer Wallet',
    icon: <DeliveryIcon />,
    path: '/manageWallet',
    submenu: false,
  },
  {
    text: 'Stock Management',
    icon: <DeliveryIcon />,
    path: '/manageStock',
    submenu: false,
  },
  {
    text: 'Refer Friend Report',
    icon: <DeliveryIcon />,
    path: '/refer-friend-report',
    submenu: false,
  },
  // {
  //   text: 'Manage Featured Restaurant',
  //   icon: <DeliveryIcon />,
  //   path: '/featured-restaurant',
  //   submenu: false,
  // },
  // {
  //   text: 'Failed Orders Management',
  //   icon: <DeliveryIcon />,
  //   path: '/failed-orders',
  //   submenu: false,
  // },
  {
    text: 'Delivery Boy Map',
    icon: <DeliveryIcon />,
    path: '/delivery-boy-map',
    submenu: false,
  },
  {
    text: 'Promotional Offers & Loyalty Rewards',
    icon: <DeliveryIcon />,
    path: '/promotional-offers',
    submenu: true,
  },
  { text: 'Reports', icon: <DeliveryIcon />, path: '/reports', submenu: true },
  {
    text: 'Push Notification',
    icon: <DeliveryIcon />,
    path: '/push-notification',
    submenu: false,
  },
   {
    text: 'Settlements',
    icon: <DeliveryIcon />,
    path: '/settlements',
    submenu: false,
  },
  {
    text: 'Settings',
    icon: <SettingsIcon />,
    path: '/settings',
    submenu: true,
  },
];

// Memoized MenuItem component
const MenuItem: React.FC<{
  item: MenuItem;
  isSelected: boolean;
  submenu: boolean;
  onClick: () => void;
  depth?: number;
}> = React.memo(({ item, isSelected, onClick, depth = 0 }) => (
  <ListItemButton
    onClick={onClick}
    selected={isSelected}
    sx={listItemStyles(isSelected)}
    style={{ paddingLeft: depth * 16 + 16 }}
  >
    <ListItemIcon sx={listItemIconStyles(isSelected)}></ListItemIcon>
    <ListItemText primary={item.text} sx={listItemTextStyles} />
  </ListItemButton>
));

// Memoized DropdownMenu component
const DropdownMenu: React.FC<{
  title: string;
  icon: React.ReactElement;
  items: MenuItem[];
  isOpen: boolean;
  isPathActive: boolean;
  onToggle: () => void;
  currentPath: string;
  onItemClick: (path: MenuItem, isSubmenuItem: boolean) => void;
}> = React.memo(
  ({
    title,
    items,
    isOpen,
    isPathActive,
    onToggle,
    currentPath,
    onItemClick,
  }) => (
    <>
      <ListItem disablePadding>
        <ListItemButton
          onClick={onToggle}
          selected={isPathActive}
          sx={listItemStyless(isPathActive)}
        >
          {/* <ListItemIcon sx={listItemIconStyles(isPathActive)}>
            {icon}
          </ListItemIcon> */}
          <ListItemText primary={title} sx={listItemTextStyles} />
          {isOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
      </ListItem>
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {items.map((item) => (
            <MenuItem
              key={item.path}
              item={item}
              isSelected={currentPath === item.path}
              onClick={() => onItemClick(item, true)}
              depth={1}
              submenu={true}
            />
          ))}
        </List>
      </Collapse>
    </>
  )
);

const Sidebar: React.FC<SidebarProps> = ({ open, onClose }) => {

  const navigate = useNavigate();
  const location = useLocation();
  const { hasAnyPermission, isSubAdmin } = usePermissions();

  const [openStates, setOpenStates] = useState<Record<string, boolean>>({
    '/settings': false,
    '/sub-admin': false,
    '/categories': false,
    '/restaurant-owners': false,
    '/manageChoice': false,
    '/restaurant-management': false,
    '/customer-management': false,
    '/item-management': false,
    '/admin-delivery': false,
    '/delivery-boys': false,
    '/manage-coupon': false,
    '/manage-CMS': false,
    '/manage-FAQ': false,
    '/review-management': false,
    '/newsletter-management': false,
    '/promotional-offers': false,
    '/reports': false
  });

  // Filter main menu and submenu items for subAdmin
  const filterMenuItems = (items: any[]) => {
    if (!isSubAdmin) return items;

    return items.filter((item) => {
      switch (item.text) {
        case 'Dashboard':
          return hasAnyPermission('dashboard');
        case 'Sub Admin':
          return hasAnyPermission('subAdmin');
        case 'Manage Store Category':
          return hasAnyPermission('storeCategory');
        case 'Manage Item Category':
          return hasAnyPermission('itemCategory');
        case 'Manage Choice Group':
          return hasAnyPermission('choiceGroup');
        case 'Manage Choices':
          return hasAnyPermission('choices');
        case 'Store Owner Management':
          return hasAnyPermission('storeOwner');
        case 'Store Management':
          return hasAnyPermission('store');
        case 'Customer Management':
          return hasAnyPermission('customer');
        case 'Join Us Requests':
          return hasAnyPermission('joinUs');
        case 'Item Management':
          return hasAnyPermission('item');
        case 'Admin Delivery Manager':
          return hasAnyPermission('deliveryManager');
        case 'Delivery boy / Driver Management':
          return hasAnyPermission('deliveryBoy');
        case 'Manage Coupon':
          return hasAnyPermission('coupon');
        case 'Manage CMS':
          return hasAnyPermission('cms');
        case 'Manage FAQ':
          return hasAnyPermission('faq');
        case 'Customer Order Management':
          return hasAnyPermission('order');
        case 'Newsletter Management':
          return hasAnyPermission('newsLetter');
        case 'Refer Friend Report':
          return hasAnyPermission('referFriend');
        case 'Stock Management':
          return hasAnyPermission('inventory');
        case 'Manage Customer Wallet':
          return hasAnyPermission('wallet');
        case 'Promotional Offers & Loyalty Rewards':
          return hasAnyPermission('promotionalAndOffers');
        case 'Manage Offers':
          return hasAnyPermission('promotionalAndOffers');
        case 'Assign Offers and Loyalty Rewards':
          return hasAnyPermission('promotionalAndOffers');
        case 'Reports':
          return hasAnyPermission('reports');
        case 'Sales Reports':
          return hasAnyPermission('reports');
        case 'Cancelled Orders Report':
          return hasAnyPermission('reports');
        case 'Admin Commission Report':
          return hasAnyPermission('reports');
        case 'Merchant Payout Report':
          return hasAnyPermission('reports');
        case 'Driver Payout Report':
          return hasAnyPermission('reports');
        case 'Refund Report':
          return hasAnyPermission('reports');
        case 'Push Notification':
          return hasAnyPermission('pushNotification');
        case 'Settlements':
          return hasAnyPermission('settlement');
        case 'Settings':
          return hasAnyPermission('settings');
        case 'Delivery Boy Map':
          return false; // Hide Delivery Boy Map for subadmins

        // For main menu
        case 'Review Management':
          return (
            hasAnyPermission('storeReview') ||
            hasAnyPermission('deliveryReview')
          );

        // For sub-menu items
        case 'Manage Restaurant Review':
          return hasAnyPermission('storeReview');
        case 'Manage Delivery Review':
          return hasAnyPermission('deliveryReview');

        default:
          return true; // Keep items that don't have specific permission keys
      }
    });
  };

  useEffect(() => {
    setOpenStates((prevState) => {
      const newState: Record<string, boolean> = {};
      for (const key of Object.keys(prevState)) {
        const submenuItems = getSubmenuItems(key);
        const shouldOpen = submenuItems.some((submenu) =>
          location.pathname === submenu.path
        );
        newState[key] = shouldOpen;
      }
      return { ...prevState, ...newState };
    });
  }, [location.pathname]);


  const handleToggle = (path: string) => {
    setOpenStates((prev) => {
      const newState: Record<string, boolean> = {};
      Object.keys(prev).forEach((key) => {
        newState[key] = key === path ? !prev[key] : false;
      });
      return newState;
    });
  };

  const handleNavigate = (
    item: string | { path: string; reviewType?: string },
    isSubmenuItem: boolean = false
  ) => {
    // ✅ If clicking a main menu item (not inside a submenu), close all submenus
    if (!isSubmenuItem) {
      setOpenStates((prev) => {
        const newState: Record<string, boolean> = {};
        Object.keys(prev).forEach((key) => {
          newState[key] = false;
        });
        return newState;
      });
    }


    if (isSubmenuItem && typeof item !== 'string') {
      if (
        item.reviewType === 'Item' ||
        item.reviewType === 'Store' ||
        item.reviewType === 'DeliveryPerson'
      ) {
        navigate(item.path, { state: { reviewType: item.reviewType } });
      } else {
        if (typeof item !== 'string') {
          navigate(item.path);
        } else {
          navigate(item);
        }
      }
    } else {
      if (typeof item !== 'string') {
        navigate(item.path);
      } else {
        navigate(item);
      }
    }
  };


  const getSubmenuItems = (path: string) => {
    switch (path) {
      case '/settings':
        return settingsMenuItems;
      case '/sub-admin':
        return subAdminMenuItems;
      case '/categories':
        return categoriesMenuItems;
      case '/restaurant-owners':
        return restaurantOwnerManagementMenuItems;
      case '/manageChoice':
        return manageChoiceMenuItems;
      case '/restaurant-management':
        return restaurantManagementMenuItems;
      case '/customer-management':
        return customerManagementMenuItems;
      case '/item-management':
        return itemManagementMenuItems;
      case '/admin-delivery':
        return adminDeliveryManagerMenuItems;
      case '/delivery-boys':
        return deliveryboyMenuItems;
      case '/manage-coupon':
        return manageCouponMenuItems;
      case '/manage-CMS':
        return manageCMS;
      case '/manage-FAQ':
        return manageFAQ;
      case '/review-management':
        return reviewManagement;
      case '/newsletter-management':
        return newsletterManagement;
      case '/promotional-offers':
        return promotionalOffers;
      case '/reports':
        return reports;
      default:
        return [];
    }
  };

  return (
    <Drawer variant="permanent" sx={drawerStyles(open)} onClose={onClose}>
      <Box sx={{ overflow: 'auto', height: '100%' }}>
        <List>
          {filterMenuItems(mainMenuItems).map((item) =>
            item.submenu ? (
              <DropdownMenu
                key={item.path}
                title={item.text}
                icon={item.icon}
                items={filterMenuItems(getSubmenuItems(item.path))}
                isOpen={openStates[item.path]}
                isPathActive={location.pathname === item.path}
                onToggle={() => handleToggle(item.path)}
                currentPath={location.pathname}
                onItemClick={handleNavigate}
              />
            ) : (
              <MenuItem
                key={item.path}
                item={item}
                isSelected={location.pathname === item.path}
                onClick={() => handleNavigate(item)}
                submenu={false}
              />
            )
          )}
        </List>
      </Box>
    </Drawer>
  );
};


export default React.memo(Sidebar);
